import apolloClient from "@/apolloClient";
import { gql } from "@apollo/client/core";



const getBackgroundColor = (teamColor) => {
    const color = teamColor?.startsWith('#') ? teamColor?.substring(1) : teamColor;
    const r = parseInt(color?.substr(0, 2), 16);
    const g = parseInt(color?.substr(2, 2), 16);
    const b = parseInt(color?.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 125 ? '#000000' : '#FFFFFF';
};

const state = {
    teams: null,
};

const getters = {
    teamIcon: (state) => (teamId) => {
        const team = state?.teams ? state?.teams.find(team => team.id === teamId) : null;

        return`<span class="rounded p-1" style="background-color: ${team?.color}; color: ${getBackgroundColor(team?.color)}" >${team?.tag}</span>`;
    }
};

const actions = {
    async init({commit}) {
        
        try {
            const response = await apolloClient.query({
                query: gql`
                    query getTeams {
                        teams {
                            id
                            tag
                            name
                            color
                        }
                    }
                `
            });

            commit('setTeams', response.data.teams);
        } catch (error) {
            console.error('Error while fetching team data:', error);
        }
    },
};

const mutations = {
    setTeams(state, teamsData) {
        state.teams = teamsData;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
